import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ProductDetailsResponseDto } from '@tiendanube/common';
import { useAppDispatch, RootStateType } from 'App/store';
import {
  cleanStatusDetails as cleanStatusDetailsAction,
  getProductById as getProductByIdAction,
} from 'domains/Catalog/Products/productsSlice';
import {
  getProductDetailsFetchStatus,
  createGetProductById,
} from 'domains/Catalog/Products/productsSlice/productSelectors';

export interface UseProductDetailsInterface {
  loading: boolean;
  error: boolean;
  success: boolean;
  fetchProduct: () => void;
  product: ProductDetailsResponseDto;
  cleanStatusDetails: () => void;
}

function useProductDetails(id: string): UseProductDetailsInterface {
  const dispatch = useAppDispatch();
  const getProductById = useMemo(createGetProductById, []);
  const product = useSelector((state: RootStateType) =>
    getProductById(state, id),
  );
  const { loading, error, success } = useSelector(getProductDetailsFetchStatus);

  const fetchProduct = useCallback(() => {
    dispatch(getProductByIdAction({ id }));
  }, [dispatch, id]);

  const cleanStatusDetails = useCallback(() => {
    dispatch(cleanStatusDetailsAction());
  }, [dispatch]);

  return useMemo(
    () => ({
      loading,
      error,
      success,
      product,
      fetchProduct,
      cleanStatusDetails,
    }),
    [loading, error, success, product, fetchProduct, cleanStatusDetails],
  );
}

export default useProductDetails;
